import desktopMinis from 'assets/images/promoOrderSuccess/d_skincare_minis.jpg';
import mobileMinis from 'assets/images/promoOrderSuccess/m_skincare_minis.jpg';

export const content = {
  US: {
    // upsell category
    skincare: {
      tracking: {
        pageView: 'Post Purchase - SK Minis Embedded Module  - Viewed ',
      },
      twoUp: {
        image: {
          mobile: mobileMinis,
          desktop: desktopMinis,
          imgAlt: '',
        },
        eyebrow: 'TRY SKINCARE FOR FREE',
        title: 'Free Skincare Starter Set',
        description:
          'Get a free trial-size Cleanser, Serum + Moisturizer ({{currency:65}}&nbsp;value).',
        cta: {
          consultationCompleted: {
            label: 'GET YOUR FREE ROUTINE',
            linkTo: '/checkout/skincare',
            dataClick: 'offer-cta',
            dataFrom: 'post-purchase-skincare-minis-offer-embedded-module',
          },
          consultationNotCompleted: {
            label: 'GET YOUR FREE ROUTINE',
            linkTo: '/consultation/skincare',
            dataClick: 'offer-cta',
            dataFrom: 'post-purchase-skincare-minis-offer-embedded-module',
          },
        },
        terms: {
          label: 'Terms & Conditions',
          dataFrom: 'post-purchase-skincare-minis-offer-embedded-module',
          dataClick: 'terms-conditions',
        },
      },
      bottomModal: {
        title: 'free skincare Starter Set',
        description:
          'Subscribe to skincare and get a personalized trial-size routine for <b>FREE</b>&nbsp;({{currency:65}}&nbsp;value)',
        conditions: `
          *Get your Skincare Starter Set ({{currency:65}}&nbsp;value) when you subscribe to Cleanser,
          Serum, and Moisturizer. Offer only valid while supplies last. Free shipping and 15% off will be
          applied to all following skincare subscription orders. Exceptions may apply. Offer valid
          while stocks last. For full details on our return policy,
          <a href="/faq/5f3da05bceb96c001a595c02" target="_blank">
            click here</a>.`,
        variant: 'subscription',
      },
    },
  },
  CA: {
    // upssell category
    skincare: {
      twoUp: {
        description: 'Get a free trial-size Cleanser, Serum + Moisturizer.',
      },
      bottomModal: {
        description:
          'Subscribe to skincare and get a personalized trial-size routine for <b>FREE</b>',
        conditions: `
          *Get your Skincare Starter Set when you subscribe to Cleanser, Serum, and Moisturizer.
          Offer only valid while supplies last. Free shipping and 15% off will be applied to all following skincare
          subscription orders. Exceptions may apply. Offer valid while supplies last. For full details
          on our return policy,
          <a href="/faq/5f3da05bceb96c001a595c02" target="_blank">
            click here</a>.`,
      },
    },
  },
};
